import { render, staticRenderFns } from "./countrySystem.vue?vue&type=template&id=4e18b635&scoped=true"
import script from "./countrySystem.vue?vue&type=script&lang=js"
export * from "./countrySystem.vue?vue&type=script&lang=js"
import style0 from "./countrySystem.vue?vue&type=style&index=0&id=4e18b635&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e18b635",
  null
  
)

export default component.exports